import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Popconfirm, message, Tag } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, KeyOutlined } from '@ant-design/icons';
import { superInspectionApi } from '../../services/api';
import InspectionAdminFormModal from './InspectionAdminFormModal';

const InspectionAdmins = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await superInspectionApi.list({ page, pageSize: pagination.pageSize });
      setData(res.data.list || []);
      setPagination({ ...pagination, current: page, total: res.data.total });
    } catch (err) {
      message.error('获取列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleAdd = () => {
    setEditing(null);
    setModalOpen(true);
  };

  const handleEdit = (record) => {
    setEditing(record);
    setModalOpen(true);
  };

  const handleToggle = async (id) => {
    try {
      const res = await superInspectionApi.toggle(id);
      message.success(res.message);
      fetchData(pagination.current);
    } catch (err) {
      message.error('操作失败');
    }
  };

  const handleResetPassword = async (id) => {
    const newPassword = '123456';
    try {
      await superInspectionApi.resetPassword(id, { newPassword });
      message.success(`密码已重置为 ${newPassword}`);
    } catch (err) {
      message.error('重置失败');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: '用户名', dataIndex: 'username', key: 'username' },
    { title: '昵称', dataIndex: 'nickname', key: 'nickname', render: (v) => v || '-' },
    {
      title: '状态', dataIndex: 'is_active', key: 'is_active', width: 80,
      render: (v) => v ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
    },
    { title: '最后登录', dataIndex: 'last_login_at', key: 'last_login_at', render: (v) => v || '-' },
    { title: '创建时间', dataIndex: 'created_at', key: 'created_at' },
    {
      title: '操作', key: 'action', width: 260,
      render: (_, record) => (
        <Space>
          <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}>编辑</Button>
          <Popconfirm title={record.is_active ? '确定禁用？' : '确定启用？'} onConfirm={() => handleToggle(record.id)}>
            <Button type="link" size="small" danger={record.is_active}>{record.is_active ? '禁用' : '启用'}</Button>
          </Popconfirm>
          <Popconfirm title="重置密码为123456？" onConfirm={() => handleResetPassword(record.id)}>
            <Button type="link" size="small" icon={<KeyOutlined />}>重置密码</Button>
          </Popconfirm>
        </Space>
      )
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2>国检账号管理</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd} style={{ background: '#1890ff' }}>新增账号</Button>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={{ ...pagination, showSizeChanger: false, onChange: (page) => fetchData(page) }}
      />

      <InspectionAdminFormModal
        open={modalOpen}
        editing={editing}
        onClose={() => setModalOpen(false)}
        onSuccess={() => { setModalOpen(false); fetchData(pagination.current); }}
      />
    </div>
  );
};

export default InspectionAdmins;
